import { Tooltip } from '@civilgrid/ui/components';
import Icon from '~/components2/Icon';
import type { RequestableLayer } from '../store';

interface Props {
  status: RequestableLayer['status'];
  row: RequestableLayer;
}

export default function Attachments({ status, row }: Props) {
  if (status !== 'complete') {
    return null;
  }

  if (row.files.length === 0) {
    return null;
  }

  return (
    <Tooltip
      text="View files"
      side="top"
      sideOffset={10}
      aria-label="Has attachments"
      data-testid={`utilities-attachments-${row.id}`}
    >
      <Icon icon="paperclip" />
    </Tooltip>
  );
}
